import styled from 'styled-components';

const DirectorsContainer = styled.article`
	${props => props.theme.breakpoints.up('xs')} {
		padding: 8% 12% 15% 12%;
	}
	${props => props.theme.breakpoints.up('sm')} {
		padding: 0% 0% 5% 0%;
	}
	ul {
		margin: 16px 0px 0px 0px;
		padding: 0;
		list-style-type: none;
	}

	li {
		float: left;
		${props => props.theme.breakpoints.up('xs')} {
			margin-right: 0px;
		}

		${props => props.theme.breakpoints.up('sm')} {
			margin-right: 30px;
		}
	}
`;

export default DirectorsContainer;
